import { Reducer } from 'redux';
import { getType } from 'typesafe-actions';
import { Organization } from '../../../types/organization';
import { RootActionType } from '../../rootActions';
import { fetchMembershipTokenFulfilled, signOut } from '../auth/actions';
import { fetchOrganizationFulfilled, updateOrganization } from './actions';

const initialState: Partial<Organization> = {
  id: undefined,
  isTrial: undefined,
  oidcProvider: undefined,
  organizationGroup: undefined,
  metadata: {},
  name: '',
  uiSettings: {},
  url: '',
  users: [],
  workspaces: [],
  sandbox: false,
};

const reducer: Reducer<typeof initialState, RootActionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case getType(fetchOrganizationFulfilled):
      return action.payload;

    case getType(updateOrganization):
      return action.payload;

    case getType(fetchMembershipTokenFulfilled):
    case getType(signOut):
      return initialState;

    default:
      return state;
  }
};

export default reducer;
